import groupBy from 'lodash/groupBy';
import sumBy from 'lodash/sumBy';
import React from 'react';
import { Table } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import ProductLabel from '../../products/ProductLabel/ProductLabel';
import { changeRequestShape } from '../../prop-types';
import { BUDGET_FIELDS_LABELS } from '../change-product-budget/constants';
import DiffHighlighter from '../change-product-budget/DiffHighlighter';
import { getBudgetDiffs } from '../change-product-budget/utils';
import { getDiffKey } from '../utils';

function MoveBudgetToWalletComment({ changeRequest }) {
  const groupedLines = groupBy(
    changeRequest.draftCampaignLines,
    line => `${line.product.id}-${line.adjustedFee}`,
  );
  const diffKey = getDiffKey(changeRequest);

  return (
    <div className="small">
      {Object.values(groupedLines).map(linesPerItem => {
        const {
          product: { id: productId },
          adjustedFee,
        } = linesPerItem[0];
        const budgetDiffs = getBudgetDiffs(linesPerItem, diffKey);
        const totalOriginValue = sumBy(budgetDiffs, 'originValue');
        const totalDraftValue = sumBy(budgetDiffs, 'draftValue');

        return (
          <div key={productId}>
            <div className="d-flex justify-content-between font-weight-semi-bold mb-2">
              <ProductLabel id={productId} />
              {adjustedFee ? (
                <span>
                  Fee -{' '}
                  <CurrencyFormat
                    value={adjustedFee * 100}
                    prefix=""
                    suffix=" %"
                    text
                  />
                </span>
              ) : null}
            </div>
            <Table className="table-sm bg-light rounded">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th className="text-right">Current</th>
                  <th className="text-right">New</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(linesPerItem[0][diffKey]).map(field => {
                  const originValue = sumBy(
                    linesPerItem,
                    `${diffKey}.${field}.originValue`,
                  );
                  const draftValue = sumBy(
                    linesPerItem,
                    `${diffKey}.${field}.draftValue`,
                  );
                  return (
                    <tr key={field}>
                      <td>{BUDGET_FIELDS_LABELS[field]}</td>
                      <td className="text-right">
                        <CurrencyFormat
                          className="text-nowrap"
                          value={originValue}
                          text
                        />
                      </td>
                      <td className="text-right">
                        <CurrencyFormat
                          className="text-nowrap"
                          value={draftValue}
                          text
                        />
                        <br />
                        <DiffHighlighter diff={draftValue - originValue} />
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td>{BUDGET_FIELDS_LABELS.budget}</td>
                  <td className="text-right">
                    <CurrencyFormat
                      className="text-nowrap"
                      value={totalOriginValue}
                      text
                    />
                  </td>
                  <td className="text-right">
                    <CurrencyFormat
                      className="text-nowrap"
                      value={totalDraftValue}
                      text
                    />
                    <br />
                    <DiffHighlighter
                      diff={totalDraftValue - totalOriginValue}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        );
      })}
    </div>
  );
}

MoveBudgetToWalletComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
};

export default MoveBudgetToWalletComment;
